import { requireAuth } from '@/functions';
import PackagesHome from '@/views/packages/packages.view.vue';
import { RouteConfig } from 'vue-router';

export const packagesRouter: Array<RouteConfig> = [
  {
    path: '/pacotes',
    name: 'packages',
    component: PackagesHome,
    beforeEnter: requireAuth,
  },
];
